declare const SI_GRAPHIC_API_URL: string

export const regionFromPath = () => {
  const regionInPath = window.location.pathname.match(
    /^\/([a-z]{2}-[a-z]{2}|[a-z]{2})\//
  )

  if (!regionInPath) {
    return 'en-gb'
  }

  return regionInPath[1]
}

export const formatSize = (
  widthMM: number,
  heightMM: number,
  units: 'cm' | 'in'
) => {
  return `${widthMM / 10} x ${heightMM / 10}${units}`
}

// https://stackoverflow.com/a/44195856
export const decodeEntities = (encodedString: string): string => {
  var translate_re = /&(nbsp|amp|quot|lt|gt);/g
  var translate: Record<string, string> = {
    nbsp: ' ',
    amp: '&',
    quot: '"',
    lt: '<',
    gt: '>',
  }
  return encodedString
    .replace(translate_re, function (_match: string, entity: any) {
      return translate[entity]
    })
    .replace(/&#(\d+);/gi, function (_match: string, numStr: any) {
      var num = parseInt(numStr, 10)
      return String.fromCharCode(num)
    })
}

export const getArtworkUrls = (urls: string[]) => {
  return urls
    .map((url: string) => {
      let asUrl: URL

      try {
        asUrl = new URL(url)

        const filename = asUrl.pathname.split('/').reverse()[0]

        if (filename.includes('-') && filename.split('-')[0].length === 25) {
          return filename.split('-').slice(1).join('-')
        }

        return filename
      } catch {
        console.error('Could not parse URL', url)
        return null
      }
    })
    .filter((path: string) => path && path !== null)
}

export const validImageOrDefault = (
  imageSrc: string,
  defaultSrc: string
): string => {
  const validExtensions = ['svg', 'pdf', 'jpg', 'jpeg', 'png', 'bmp', 'gif']

  if (validExtensions.some((ext) => imageSrc.endsWith(`.${ext}`))) {
    return imageSrc
  }

  return defaultSrc
}

export const getGraphicImageURL = (s: string, w = 250) => {
  const opts = new URLSearchParams()
  opts.set('preview', 'true')
  opts.set('cutline', 'false')
  opts.set('w', `${w}`)

  return (
    s.replace('graphic://', `${SI_GRAPHIC_API_URL}/design/`) +
    `/render?${opts.toString()}`
  )
}

export const mm2in = (n: number) => n / 25.4
export const cm2in = (n: number) => n / 2.54
export const in2cm = (n: number) => n * 2.54
export const in2mm = (n: number) => n * 25.4
export const cm2mm = (n: number) => n * 10
export const mm2cm = (n: number) => n / 10

export function decodeHTMLEntities(text: string) {
  var textArea = document.createElement('textarea')
  textArea.innerHTML = text
  return textArea.value
}
